export default __webpack_public_path__ + "static/media/CNo.52-3.7c9189ad.jpg";